export const SCHEDULE_SPECTATOR_VIEW = 'SCHEDULE_SPECTATOR_VIEW';
